import React from "react";
import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";
import InterviewUsersAnalyticsContent from "../../../components/AdminPanel/InterviewUserAnalytics/InterviewUsersAnalyticsContent";

const InterviewUserAnalytics = () => {
  return (
    <AdminPanelLayout>
      <InterviewUsersAnalyticsContent />
    </AdminPanelLayout>
  );
};

export default InterviewUserAnalytics;

